import React from 'react';
import Card from '@mui/material/Card';
import { Paper } from '@mui/material';
import { useState } from 'react';
import CardContent from '@mui/material/CardContent';
import { KeyboardArrowRight } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { useContext } from 'react';
import { Box } from '@mui/system';
import { ServiceFlyout } from '../ServiceFlyout/ServiceFlyout';
import ApplicationContext from '../../context/applicationContext';
import { getIconFromSubItemsArray } from '../../shared/helper';
import { DEFAULT_NULL_REPLACEMENT } from '../../shared/constants';
import { FETCH_FORMULARY_BY_ID } from '../../services/FormularyQueries/FormularyQueries';
import { useLazyQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { FORMULARY } from '../../shared/Strings';

const Dat = {
  COPAY_OPTION: 'Copay Option',
  COINSURANCE_OPTION: 'Coinsurance Option',
  COPAY_AMOUNT: 'Copay Amount',
  COINSURANCE_RATE: 'Coinsurance Rate',
  PHARMACY_TYPE: 'Pharmacy Type',
};

const FormularyList = props => {
  return (
    <>
      {props.data.map((val, index) => (
        <Paper
          key={index}
          variant="outlined"
          sx={{ borderRadius: '12px', p: 3, flex: 1, mb: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', mb: 1 }}>
            <Typography variant="navSelected">
              COST SHARING OPTION {index + 1}
            </Typography>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <Typography variant="serviceColumnName">
                  {Dat.COPAY_OPTION}
                </Typography>
                <Typography variant="h5">
                  {val?.extension
                    ? val?.extension?.[0]?.valueCoding?.display === null
                      ? DEFAULT_NULL_REPLACEMENT
                      : val?.extension?.[0]?.valueCoding?.display
                    : DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="serviceColumnName">
                  {Dat.COINSURANCE_OPTION}
                </Typography>
                <Typography variant="h5">
                  {' '}
                  {val?.extension
                    ? val?.extension[1]?.valueCoding?.display === null
                      ? DEFAULT_NULL_REPLACEMENT
                      : val?.extension[1]?.valueCoding?.display
                    : DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <Typography variant="serviceColumnName">
                  {Dat.COPAY_AMOUNT}
                </Typography>
                <Typography variant="h5">
                  {val?.extension
                    ? val?.extension[2]?.valueCoding?.display === null
                      ? DEFAULT_NULL_REPLACEMENT
                      : val?.extension[2]?.valueCoding?.display
                    : DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="serviceColumnName">
                  {Dat.COINSURANCE_RATE}
                </Typography>
                <Typography variant="h5">
                  {val?.extension
                    ? val?.extension[3]?.valueCoding?.display === null
                      ? DEFAULT_NULL_REPLACEMENT
                      : val?.extension[3]?.valueCoding?.display
                    : DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Typography variant="serviceColumnName">
                  {Dat.PHARMACY_TYPE}
                </Typography>
                <Typography variant="h5">
                  {val?.extension
                    ? val?.extension[4]?.valueCoding?.display === null
                      ? DEFAULT_NULL_REPLACEMENT
                      : val?.extension[4]?.valueCoding?.display
                    : DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      ))}
    </>
  );
};

function FormularyItem(props) {
  const [openFlyout, setOpenFlyout] = useState(false);
  const [flyoutData, setFlyoutData] = useState({ code: '', extension: [''] });
  const { menuItems } = useContext(ApplicationContext);
  const { enqueueSnackbar } = useSnackbar();
  const [fetchFormularyById, fetchFormularyByIdCall] = useLazyQuery(
    FETCH_FORMULARY_BY_ID,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(FORMULARY.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        setFlyoutData(res.fetchFormularyById);

        setOpenFlyout(true);
      },
    }
  );
  const loading = fetchFormularyByIdCall.loading;
  const onClick = () => {
    fetchFormularyById({
      variables: {
        formularyId: props.data.id,
      },
    });
  };
  const closeFlyout = () => {
    setOpenFlyout(false);
  };

  return (
    <div>
      <Card
        sx={{
          width: '300px',
          height: '70px',
          borderRadius: ' 8px',
          mr: '16px',
          cursor: 'pointer',
        }}
        onClick={onClick}>
        <CardContent>
          <Grid container wrap="nowrap" spacing={2}>
            <Grid item>
              <img
                src={props.icon}
                alt={FORMULARY.IMAGE_ALTERNATE_TEXT.formulary}
                width="30px"
              />
            </Grid>
            <Grid item xs zeroMinWidth>
              <Typography noWrap sx={{ fontWeight: 600, fontSize: 16 }}>
                {props.data.title}
              </Typography>
              <Typography noWrap>{props.data.sub_title}</Typography>
            </Grid>
            <Grid item>
              <KeyboardArrowRight
                sx={{
                  display: 'flex',
                  color: '#838383',
                  position: 'absolute',
                  mt: 1,
                  ml: -2,
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        icon={
          menuItems
            ? getIconFromSubItemsArray(
                menuItems?.Medical?.subItems,
                'Formulary'
              )
            : null
        }
        category={FORMULARY.TITLE_TEXT}
        title={
          flyoutData?.code?.coding
            ? flyoutData?.code?.coding?.[0]?.display ||
              flyoutData?.code?.text ||
              DEFAULT_NULL_REPLACEMENT
            : flyoutData?.code?.text || DEFAULT_NULL_REPLACEMENT
        }>
        <FormularyList data={flyoutData.extension} />
      </ServiceFlyout>
      <SimpleBackdrop open={loading} />
    </div>
  );
}

export default FormularyItem;
